<template>
    <ul v-if="cardStyle==='card'" class="grid grid-cols-1 gap-10 pb-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
        role="list">
        <li v-for="i in numOfCards" :key="i"
            class="flex flex-col col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm saturate-100 hover:saturate-200 rounded-t-2xl">
            <div role="status" class="max-w-sm p-4 text-center rounded shadow-sm animate-pulse md:p-6 rounded-t-2xl">
                <div class="flex items-center justify-center w-40 h-40 mx-auto mb-4 bg-gray-300 rounded-2xl dark:bg-gray-700">
                    <svg class="w-12 h-12 text-gray-200 dark:text-gray-600" xmlns="http://www.w3.org/2000/svg"
                         aria-hidden="true" fill="currentColor" viewBox="0 0 640 512">
                        <path
                                d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/>
                    </svg>
                </div>
                <div class="flex items-center justify-center mt-8">
                    <div class="w-48 h-4 mb-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                </div>
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div class="flex items-center justify-center mt-8 space-x-3">

                    <div>

                        <div class="w-48 h-6 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    </div>
                </div>
                <span class="sr-only">Loading...</span>
            </div>
        </li>
    </ul>
    <div  v-else class="grid grid-cols-1 gap-10 pb-5 md:grid-cols-2">
        <div v-for="i in numOfCards" :key="i" 
             class="relative flex items-center px-6 py-5 space-x-3 bg-white border border-clay-500 rounded-lg shadow-sm focus-within:ring-2 focus-within:ring-electric-500 focus-within:ring-offset-2 hover:border-gray-400">
            <div class="shrink-0">
                <div class="flex items-center justify-center mx-auto mb-4 bg-gray-300 w-14 h-14 rounded-2xl dark:bg-gray-700">
                    <svg class="w-6 h-6 text-gray-200 dark:text-gray-600" xmlns="http://www.w3.org/2000/svg"
                         aria-hidden="true" fill="currentColor" viewBox="0 0 640 512">
                        <path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"></path>
                    </svg>
                </div>
            </div>
            <div class="flex-1 min-w-0">
                <div class="w-48 h-4 mb-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div class="w-32 h-2.5 mb-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div class="flex-1">
                <div class="h-2.5 w-16 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            </div>
            <div class="flex-1 min-w-20">
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
            <div class="text-right flex-0">
                <div class="grid grid-cols-2 space-x-1">
                    <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-8"></div>
                    <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-8"></div>
                </div>
            </div>
        </div>
    </div>
</template>


<script lang="ts" setup>
// @ts-ignore
import {defineProps, ref} from 'vue';

const props = defineProps({
    numOfCards: {
        type: Number,
        default: 1
    },
    cardStyle: {
        type: String,
        default: 'card'
    }
})

const numOfCards = ref(props.numOfCards);
const cardStyle = ref(props.cardStyle);
</script>